import { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  openConfirmToggle,
  openFormModal,
  openViewModal,
} from "../../store/reducers/plantels/plantels.reducer";
import { getPlantelByIdThunk } from "../../store/reducers/plantels/plantels.thunks";
import Modal from "../UI/Modal";

const PlantelActions = ({ plantel }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);

  const handleView = () => {
    setModalOpen(false);
    dispatch(openViewModal());
    dispatch(getPlantelByIdThunk(plantel.id));
  };

  const handleEdit = async () => {
    setModalOpen(false);
    await dispatch(getPlantelByIdThunk(plantel.id));
    dispatch(openFormModal({ mode: "edit" }));
  };

  const handleToggle = () => {
    setModalOpen(false);
    dispatch(openConfirmToggle({ id: plantel.id }));
  };

  const handleNavigate = (path) => {
    setModalOpen(false);
    navigate(path);
  };

  const itemClass =
    "d-flex align-items-center gap-3 px-3 py-3 rounded-3 w-100 border-0 bg-hover-neutral-100 text-hover-neutral-900";

  return (
    <>
      <button
        className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
        onClick={() => setModalOpen(true)}
      >
        <Icon icon="mdi:cog-outline" width="16" />
        <span>Acciones</span>
      </button>

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        title={`Acciones — ${plantel.nombre}`}
        size="md"
      >
        <div className="d-flex flex-column gap-1">
          {/* Ver */}
          <button className={itemClass} onClick={handleView}>
            <Icon icon="mdi:eye-outline" width={20} className="text-primary" />
            <div className="text-start">
              <div className="fw-medium">Ver plantel</div>
              <div className="text-xs text-secondary-light">Detalles del plantel</div>
            </div>
          </button>

          {/* Editar */}
          <button className={itemClass} onClick={handleEdit}>
            <Icon icon="mdi:pencil-outline" width={20} className="text-primary" />
            <div className="text-start">
              <div className="fw-medium">Editar plantel</div>
              <div className="text-xs text-secondary-light">Modificar datos del plantel</div>
            </div>
          </button>

          {/* Activar / Desactivar */}
          <button className={itemClass} onClick={handleToggle}>
            <Icon
              icon={plantel.is_active ? "mdi:toggle-switch-off-outline" : "mdi:toggle-switch-outline"}
              width={20}
              className={plantel.is_active ? "text-danger" : "text-success"}
            />
            <div className="text-start">
              <div className="fw-medium">{plantel.is_active ? "Desactivar" : "Activar"}</div>
              <div className="text-xs text-secondary-light">
                {plantel.is_active ? "Deshabilitar este plantel" : "Habilitar este plantel"}
              </div>
            </div>
          </button>

          <hr className="my-2" />

          {/* Configuración de talentos */}
          <button className={itemClass} onClick={() => handleNavigate(`/ver-talentos/${plantel.id}`)}>
            <Icon icon="mdi:cog-outline" width={20} className="text-primary" />
            <div className="text-start">
              <div className="fw-medium">Configuración de talentos</div>
              <div className="text-xs text-secondary-light">Gestionar talentos, frases y algoritmo</div>
            </div>
          </button>

          {/* Conversaciones del plantel */}
          <button className={itemClass} onClick={() => handleNavigate(`/ver-conversaciones-talentos/${plantel.id}`)}>
            <Icon icon="mdi:forum-outline" width={20} className="text-primary" />
            <div className="text-start">
              <div className="fw-medium">Conversaciones del plantel</div>
              <div className="text-xs text-secondary-light">Cómo conducir cada conversación</div>
            </div>
          </button>

          {/* Contenido de conversaciones */}
          <button className={itemClass} onClick={() => handleNavigate(`/ver-contenido-conversaciones-talentos/${plantel.id}`)}>
            <Icon icon="mdi:text-box-edit-outline" width={20} className="text-primary" />
            <div className="text-start">
              <div className="fw-medium">Contenido de conversaciones</div>
              <div className="text-xs text-secondary-light">Editar propósito y uso por talento</div>
            </div>
          </button>

          {/* Confirmación de talentos */}
          <button className={itemClass} onClick={() => handleNavigate(`/ver-confirmación-talentos/${plantel.id}`)}>
            <Icon icon="mdi:brain" width={20} className="text-primary" />
            <div className="text-start">
              <div className="fw-medium">Confirmación de talentos</div>
              <div className="text-xs text-secondary-light">Frases y preguntas de confirmación</div>
            </div>
          </button>

          {/* Aplicación de talentos y Fortalezas (viejos) ocultos — reemplazados por Fortalezas 2.0.
              Rutas /ver-aplicacion-de-talentos/:id y /ver-fortalezas-talentos/:id siguen activas. */}

          {/* Fortalezas 2.0 */}
          <button className={itemClass} onClick={() => handleNavigate(`/ver-fortalezas-2/${plantel.id}`)}>
            <Icon icon="mdi:comment-question-outline" width={20} className="text-primary" />
            <div className="text-start">
              <div className="fw-medium">Fortalezas 2.0</div>
              <div className="text-xs text-secondary-light">Fortalezas y afirmaciones</div>
            </div>
          </button>
        </div>
      </Modal>
    </>
  );
};

export default PlantelActions;
